import * as React from 'react'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { IServiceFrequency } from '@user/store/serviceFrequency/typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { OldServiceContents } from './variants/OldServiceContents'
import { NewServiceContents } from './variants/NewServiceContents'
import { useOrderedServiceList } from './hooks/useOrderedServiceList'

export type Props = {
  onDelete?: () => void
  onEditClick: (service: ILeadOppProduct) => void
  disableEdit: boolean
  serviceFrequencies: IServiceFrequency[]
  minimumServicesCount?: number
  deleteWarningMessage?: string
  entityType: ENTITY_TYPES
  localMode: boolean
  readOnly?: boolean
  useSystemName?: boolean
  services: ILeadOppProduct[]
  totalServicesCount?: number
  variant: 'old' | 'new'
}

export const ServiceList: React.FC<Props> = (props) => {
  const { services, variant } = props

  const orderedServices = useOrderedServiceList(services)

  switch (variant) {
    case 'old':
      return <OldServiceContents {...props} services={orderedServices} />
    case 'new':
      return <NewServiceContents {...props} services={orderedServices} />
  }
}
ServiceList.displayName = 'ServiceList'
